// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import AdminDataRow from 'components/common/AdminDataRow';
import AdminSection from 'components/common/AdminSection';
import BackButton from 'components/common/BackButton';
import Button from 'components/common/Button';
import UserForm from 'components/forms/UserForm';
// APOLLO
import getUserQuery from 'ApolloClient/Queries/getUser';
import adminDeleteUser from 'ApolloClient/Mutations/adminDeleteUser';
import saveUserAccount from 'ApolloClient/Mutations/saveUserAccount';
import { compose, graphql } from 'react-apollo';
import createInviteUrl from 'ApolloClient/Mutations/createInviteUrl';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import ErrorHelpers from 'lib/helpers/ErrorHelpers/index';
// ANTD
import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import 'antd/lib/popconfirm/style/css';

const btn = styled.button`
  background: transparent;
  border: 0px;
`;

const CantFindUser = ({ onClick }) => {
  return (
    <PageContainer>
      We can not find this user.... <btn onClick={onClick}>Go Back</btn>
    </PageContainer>
  );
};

class AdminUserDetail extends React.PureComponent {
  state = {
    editing: false,
    loading: false,
  };

  onDeleteUser = async () => {
    const user = this.props.getUserQuery.getUser;
    let variables = {
      _id: user._id,
    };

    try {
      await this.props.adminDeleteUser({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    message.success('User successfully deleted!');
    window.location.reload();
  };

  handleSaveAccountSubmit = async values => {
    const user = this.props.getUserQuery.getUser;
    let variables = {
      _id: user._id,
      params: {
        ...values,
      },
    };
    try {
      await this.props.saveUserAccount({ variables });
      message.success('Profile saved!');
    } catch (err) {
      console.log(err);
    }
    message.success('User successfully saved!');
    window.location.reload();
  };

  onHandleCreateInvite = async () => {
    try {
      this.setState({
        loading: true,
      });
      await this.props.createInviteUrl({
        variables: {
          id: this.props.match.params.userId,
        },
        refetchQueries: [
          {
            query: getUserQuery,
            variables: {
              _id: this.props.match.params.userId,
            },
          },
        ],
      });
      this.setState({
        loading: false,
      });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const user = this.props.getUserQuery.getUser;
    // check to see if organization exists
    if (!user) {
      return <CantFindUser onClick={this.props.history.goBack} />;
    }

    return (
      <div>
        {this.state.loading && (
          <div
            style={{
              zIndex: 1000,
              background: 'rgba(0,0,0,.25)',
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          >
            Loading
          </div>
        )}
        <BackButton />
        <PageContainer>
          <React.Fragment>
            <AdminSection
              label={user.profile.firstName}
              onEdit={() => this.setState({ editing: !this.state.editing })}
              onEditText={!this.state.editing ? 'edit' : 'cancel'}
            >
              {!this.state.editing ? (
                <React.Fragment>
                  <AdminDataRow label="ID">{user._id}</AdminDataRow>
                  <AdminDataRow label="First">{user.profile.firstName}</AdminDataRow>
                  <AdminDataRow label="Last">{user.profile.lastName}</AdminDataRow>
                  <AdminDataRow label="Email">{user.emails[0].address}</AdminDataRow>
                  <AdminDataRow label="location">{user.location}</AdminDataRow>
                  <AdminDataRow label="direct line">{user.directLine}</AdminDataRow>
                  <AdminDataRow label="mobile number">{user.mobileNumber}</AdminDataRow>
                  <AdminDataRow label="industry">{user.industry}</AdminDataRow>
                  <AdminDataRow label="role">{user.role}</AdminDataRow>
                  <AdminDataRow label="Invite URL">
                    {user.invite ? <a href={user.invite}>{user.invite}</a> : 'No invite url for this user'}
                  </AdminDataRow>
                  {user.organizations && (
                    <AdminDataRow label="Organizations">
                      {user.organizations.map(organization => (
                        <div>
                          <Link to={`/admin/organization/${organization._id}`}>
                            {organization && organization.title}
                          </Link>
                        </div>
                      ))}
                    </AdminDataRow>
                  )}
                  {user.dashboards && (
                    <AdminDataRow label="Dashboards">
                      {user.dashboards.map(dashboard => (
                        <div>
                          <Link to={`/admin/dashboards/${dashboard._id}`}>{dashboard && dashboard.name}</Link>
                        </div>
                      ))}
                    </AdminDataRow>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <UserForm user={user} handleSubmit={this.handleSaveAccountSubmit} />
                </React.Fragment>
              )}
            </AdminSection>
            <AdminSection label="ACTIONS">
              <Button onClick={this.onHandleCreateInvite}>Generate New Invite URL</Button>
            </AdminSection>
            <AdminSection label="DANGER ZONE">
              <Popconfirm
                placement="topLeft"
                title="Are you sure?"
                onConfirm={this.onDeleteUser}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger">Delete User</Button>
              </Popconfirm>
            </AdminSection>
          </React.Fragment>
        </PageContainer>
      </div>
    );
  }
}

let options = props => ({
  variables: {
    _id: props.match.params.userId,
  },
});

export default compose(
  graphql(getUserQuery, { options, name: 'getUserQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'getUserQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'getUserQuery' }),
  graphql(adminDeleteUser, { name: 'adminDeleteUser' }),
  graphql(saveUserAccount, { name: 'saveUserAccount' }),
  graphql(createInviteUrl, { name: 'createInviteUrl' }),
)(AdminUserDetail);



// WEBPACK FOOTER //
// ./src/routes/admin-user-detail/index.js